<div class="form-user-domains">
    <mon-spinner [progress]="progress" class="spinner">
        <table class="table table-hover" monSelectAllCheckbox>
            <thead>
                <tr>
                    <th translate>Domains</th>
                    <th class="col-10 text-right">
                        <span id="domain-header-visible" translate>Visible</span>
                        <input id="domain-visible-all" class="ml-1 vertical-align-middle" type="checkbox" aria-labelledby="domain-header-visible">
                    </th>
                    <th class="col-10 text-right">
                        <span id="domain-header-send-report" translate>Send report</span>
                        <input id="domain-send-report-all" class="ml-1 vertical-align-middle" type="checkbox" aria-labelledby="domain-header-send-report">
                    </th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let domain of domains; let i = index; trackBy: trackByIndex">
                    <tr>
                        <td>{{ domain.title }}</td>
                        <td class="text-right">
                            <span [id]="'domain-visible-label-' + i" class="tw-sr-only" translate>Visible</span>
                            <input type="checkbox"
                                   [id]="'domain-visible-' + i"
                                   [name]="'domainVisible' + i"
                                   (click)="setVisible(domain, 'domain_users', 'domain_id')"
                                   [disabled]="user.customer_admin"
                                   [checked]="domainIsVisible(domain)"
                                   [attr.aria-labelledby]="'domain-visible-label-' + i">
                        </td>
                        <td class="text-right">
                            <span [id]="'domain-send-report-label-' + i" class="tw-sr-only" translate>Send report</span>
                            <input type="checkbox"
                                   [id]="'domain-send-report-' + i"
                                   [name]="'domainSendReport' + i"
                                   (click)="setSendReport(domain, 'domain_users', 'domain_id')"
                                   [disabled]="!domainIsVisible(domain)"
                                   [checked]="domainHasSendReport(domain)"
                                   [attr.aria-labelledby]="'domain-send-report-label-' + i">
                        </td>
                    </tr>
                    <tr *ngFor="let domainGroup of domain.domain_groups | orderBy: 'title'; let j = index; trackBy: trackByDomainGroupIndex">
                        <td><span class="fas fa-clone pull-left visibility-45"></span>{{ domainGroup.title }}</td>
                        <td class="text-right">
                            <span [id]="'domain-group-visible-label-' + i + '-' + j" class="tw-sr-only" translate>Visible</span>
                            <input type="checkbox"
                                   [id]="'domain-group-visible-' + j"
                                   [name]="'domainGroupVisible' + j"
                                   (click)="setVisible(domainGroup, 'domain_group_members', 'domain_group_id')"
                                   [disabled]="user.customer_admin"
                                   [checked]="domainGroupIsVisible(domainGroup)"
                                   [attr.aria-labelledby]="'domain-group-visible-label-' + i + '-' + j">
                        </td>
                        <td class="text-right">
                            <span [id]="'domain-group-send-report-label-' + i + '-' + j" class="tw-sr-only" translate>Send report</span>
                            <input type="checkbox"
                                   [id]="'domain-group-send-report-' + j"
                                   [name]="'domainGroupSendReport' + j"
                                   (click)="setSendReport(domainGroup, 'domain_group_members', 'domain_group_id')"
                                   [disabled]="!domainGroupIsVisible(domainGroup)"
                                   [checked]="domainGroupHasSendReport(domainGroup)"
                                   [attr.aria-labelledby]="'domain-group-send-report-label-' + i + '-' + j">
                        </td>
                    </tr>
                </ng-container>
            </tbody>
        </table>
    </mon-spinner>
    <div class="form-user-domains-pagination" *ngIf="domains.length < total">
        <table-page-size [totalItems]="total"
                [pageSize]="pageSize"
                (onPerPageChange)="onPageSizeChange($event)"
                class="mr-auto">
        </table-page-size>
        <ngb-pagination
            *ngIf="domains.length < total"
            [collectionSize]="total"
            [page]="page"
            (pageChange)="onPageChange($event)"
            [pageSize]="pageSize"
            [maxSize]="4"
            [rotate]="true"
            [boundaryLinks]="false">
        </ngb-pagination>
    </div>
</div>
